import OverlayLoader from "components/loader/OverlayLoader";
import InfoIconTooltip from "components/tooltip/InfoIconTooltip";
import { LinkPrimaryArrow } from "components/link/Link";
import { ArchiveItem } from "models/ArchiveItem";
import { Icon } from "components/icon/Icon";
import ArchivePreviewItem from "../archivePreviewItem/ArchivePreviewItem";

import "./ArchivePreview.scss";

type Props = {
  archivedFiles: ArchiveItem[];
  customerId: string;
  isLoading: boolean;
  showMore: () => void;
  minimize: () => void;
  showExpand: boolean;
  showMinimize: boolean;
};

export default function ArchivePreview({
  archivedFiles,
  customerId,
  isLoading,
  showMore,
  minimize,
  showExpand,
  showMinimize
}: Props) {
  let noContent = <></>;
  if (archivedFiles.length === 0) {
    noContent = <li>Inga händelser i dokumentarkivet</li>;
  }

  let expand = <></>;
  if (
    showExpand &&
    archivedFiles.length !== 0 &&
    archivedFiles.length < 50 &&
    archivedFiles.length >= 5
  ) {
    expand = (
      <div className="expand">
        <div onClick={showMore}>
          <span>Visa fler</span>
          <Icon name="angle-down" />
        </div>
      </div>
    );
  }
  if (showMinimize) {
    expand = (
      <div className="expand">
        <div onClick={minimize}>
          <span>Återställ</span>
          <Icon name="angle-up" />
        </div>
      </div>
    );
  }

  return (
    <section
      aria-label="Händelser i dokumentarkivet"
      className="archivePreview"
    >
      <h1 className="m-0 d-flex align-items-center">
        Händelser i dokumentarkivet{" "}
        <InfoIconTooltip className="ml-3">
          Här ser du när ditt kundteam har laddat upp en ny fil eller sparat ned
          ett dokument i en dokumentmapp. När du klickar på informationen laddar
          du ned filen och genom att klicka en gång till på den nedladdade filen
          kan du öppna filen och titta på dokumentet. Här visas de fem senast
          uppladdade filerna.
        </InfoIconTooltip>
      </h1>
      <hr className="header-border" />
      <OverlayLoader isLoading={isLoading}>
        <div>
          <ul>
            {noContent}
            {archivedFiles.map((document) => {
              return (
                <ArchivePreviewItem
                  key={document.id}
                  document={document}
                  customerId={customerId}
                />
              );
            })}
          </ul>
          {expand}
        </div>
      </OverlayLoader>
      <hr className="footer-border" />
      <LinkPrimaryArrow to="/archive">Till dokumentarkivet</LinkPrimaryArrow>
    </section>
  );
}
